import { render } from "./CashdeskDatatableTDXReportView.vue?vue&type=template&id=7b6b4a90"
import script from "./CashdeskDatatableTDXReportView.vue?vue&type=script&lang=js"
export * from "./CashdeskDatatableTDXReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__